import { Inject, Service } from 'typedi';
import { BaseHttp } from '@enterprise/common';
import { environment } from '../environment/environment';
import { EmbedDeepLink, EmbedLinksResponse, LookerUserContext } from '../core/models';
import { sortBy } from 'lodash';

export class EmbedLinkParams {
    timeFrame?: Date;
    practiceName?: string;
}

@Service()
export class AnalyticsService {
    constructor(@Inject('http') private readonly http: BaseHttp) {}

    getEmbedLinks(params?: EmbedLinkParams): Promise<EmbedLinksResponse> {
        return this.http.get(`/v2/analytics/looker/embed-link`, { params });
    }

    getDeepLink(id: string): Promise<EmbedDeepLink> {
        return this.http.get(`/v2/analytics/looker/embed-link/deep/${id}`);
    }

    async getLookerStatus(): Promise<LookerUserContext> {
        const entities: LookerUserContext = await this.http.get('/v2/analytics/looker/user-context');
        entities.connectedPractices = sortBy(entities.connectedPractices, (practice) => practice.name);

        return entities;
    }

    async getEnrollments(): Promise<Record<string, unknown>[]> {
        try {
            return await this.http.get(`${environment.PRACTICE_CONNECT.BASE_API_URL}/v1/enrollment`);
        } catch {
            return [];
        }
    }
}
